var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCameraDisabled = function SvgCameraDisabled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35.08 35.08"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".camera-disabled_svg__cls-1{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:2.92px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "camera-disabled_svg__Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "camera-disabled_svg__Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "camera-disabled_svg__cls-1",
    d: "M23.39 23.39v1.46a2.93 2.93 0 0 1-2.93 2.92H4.39a2.93 2.93 0 0 1-2.93-2.92V10.23a2.93 2.93 0 0 1 2.93-2.92h2.92m8.27 0h4.88a2.93 2.93 0 0 1 2.93 2.92v4.88l1.46 1.47 8.77-6.35v14.62M1.46 1.46l32.16 32.16"
  })))));
};
export default SvgCameraDisabled;